import { Container, Grid, Skeleton } from '@mui/material';

const BookingPurchaseSkeleton = () => {
  return (
    <Container>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={3}></Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton
            variant="rect"
            width={'100%'}
            height={40}
            style={{ margin: '10px auto', borderRadius: '3px' }}
            animation="wave"
          />
          <Skeleton
            width={'80%'}
            variant="text"
            animation="wave"
            style={{ margin: '10px auto' }}
          />
          <Skeleton
            width={'80%'}
            variant="text"
            animation="wave"
            style={{ margin: '10px auto' }}
          />
          <Skeleton
            width={'80%'}
            variant="text"
            animation="wave"
            style={{ margin: '10px auto' }}
          />
          <Skeleton
            variant="rect"
            width={'30%'}
            height={36}
            style={{ margin: '10px auto', borderRadius: '5px' }}
            animation="wave"
          />
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
      </Grid>
    </Container>
  );
};

export default BookingPurchaseSkeleton;
